// extracted by mini-css-extract-plugin
export var sliderRange = "_pz-2";
export var sliderRoot = "_pz-0";
export var sliderThumb = "_pz-3";
export var sliderTrack = "_pz-1";